import React from 'react'
import { useTranslation } from 'react-i18next'

import { useAPIGetReservationPincode } from '../../api/apiHooks/useAPIGetReservationPincode'
import { useAPIGetReservationRecurrencePincode } from '../../api/apiHooks/useAPIGetReservationRecurrencePincode'

type ReservationPincodeProps = {
  contractUuid: string
  reservationId: number
  reservationRecurrenceId?: number | null
  recurring: boolean
}

export const ReservationPincode: React.FC<ReservationPincodeProps> = ({
  contractUuid,
  reservationId,
  reservationRecurrenceId,
  recurring,
}) => {
  const { t } = useTranslation(['reservations'])

  const singlePincodeQuery = useAPIGetReservationPincode(
    contractUuid,
    reservationId,
    !recurring
  )

  const recurrencePincodeQuery = useAPIGetReservationRecurrencePincode(
    contractUuid,
    reservationRecurrenceId || 0,
    recurring && reservationRecurrenceId !== null
  )

  const query = recurring ? recurrencePincodeQuery : singlePincodeQuery

  if (query.isLoading) {
    return (
      <div className="flex items-center gap-2">
        <div className="size-4 animate-spin rounded-full border-2 border-gray-300 border-t-blue-600" />
        <span className="text-sm text-gray-600">
          {t('reservations:loadingPincode')}
        </span>
      </div>
    )
  }

  if (query.isError) {
    return (
      <div className="text-sm text-red-600">
        {t('reservations:pincodeLoadError')}
      </div>
    )
  }

  if (!query.data?.pincode) {
    return null
  }

  return <div>{t('reservations:pincode', { pincode: query.data.pincode })}</div>
}
